<script lang="ts">
	import type { MarkdownOptions } from '@magidoc/plugin-svelte-marked';
	import type { Renderers } from '@magidoc/plugin-svelte-marked';
	import { BaseParagraph, type BaseParagraphProps } from '../BaseParagraph';

	interface Props {
		token: BaseParagraphProps['token'];
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
	}

	let { token, options, renderers }: Props = $props();
</script>

<BaseParagraph variant="body2" boldVariant="label3" {token} {options} {renderers} />
